import type { ConsentDoc } from '@/shared/data-types';
import { FullScreenDialog } from '@/shared/ui';
import { ConsentDocBody } from './consent-doc-body';

export interface ConsentModalProps {
  consent: ConsentDoc;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * 약관 원문 모달 — 고객센터 약관 목록·마케팅 동의 '내용 보기'가 공유. 호출처가 **이미 문서를 쥔** 판이라
 * 조회 없이 바로 렌더한다(원문 `content` 가 목록 응답에 인라인). 문서를 쥐지 않은 표면은 `ConsentDocModal`.
 * footer 이용약관(`AgreementModal`)과 동일 방식(`FullScreenDialog`)이되 API 는 app-legacy(v3) consent.
 * FullScreenDialog title 은 sr-only(a11y) — 가시 제목(약관명)은 `ConsentDocBody` 의 h1.
 */
export function ConsentModal({ consent, open, onOpenChange }: ConsentModalProps) {
  return (
    <FullScreenDialog open={open} onOpenChange={onOpenChange} title={consent.name}>
      <ConsentDocBody consent={consent} />
    </FullScreenDialog>
  );
}
